import React from 'react';
import { Carousel, Row, Col } from 'react-bootstrap';
import '../scss/components/_before-after-carousel.scss';

const BeforeAfterCarousel = ({ beforeAfterImages }) => {
  return (
    <div className="before-after-carousel">
      <Carousel interval={null} indicators={true} controls={true}>
        {beforeAfterImages.map((item, index) => (
          <Carousel.Item key={index}>
            <Row className="g-0">
              <Col xs={12}>
                <div className="comparison-container">
                  <div className="image-wrapper before">
                    <div className="image-content">
                      <img
                        src={item.before}
                        alt="Antes del trabajo"
                        className="d-block w-100"
                        onError={(e) => {
                          e.target.src = '/assets/stdominicana/images/placeholder.jpg';
                        }}
                      />
                      <div className="label-overlay">
                        <span className="label-text">ANTES</span>
                      </div>
                    </div>
                  </div>
                  <div className="image-wrapper after">
                    <div className="image-content">
                      <img
                        src={item.after}
                        alt="Después del trabajo"
                        className="d-block w-100"
                        onError={(e) => {
                          e.target.src = '/assets/stdominicana/images/placeholder.jpg';
                        }}
                      />
                      <div className="label-overlay">
                        <span className="label-text">DESPUÉS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            {item.description && (
              <Carousel.Caption>
                <p>{item.description}</p>
              </Carousel.Caption>
            )}
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default BeforeAfterCarousel;
